import { pluralizeMonths, pluralizeYears, pluralizeDays } from 'shared/lib/pluralize';

import { iso8601DurationToYearsMonthsDays } from './iso8601DurationToYearsMonthsDays';

/** P5Y6M3D => "5 лет 6 месяцев 3 дня" */
export const pluralizeIso8601Period = (isoPeriod: string) => {
  const { months, days, years } = iso8601DurationToYearsMonthsDays(isoPeriod);
  const yearsPart = years ? `${years} ${pluralizeYears(years)}` : '';
  const monthsPart = months ? `${months} ${pluralizeMonths(months)}` : '';
  const daysPart = days ? `${days} ${pluralizeDays(days)}` : '';
  return [yearsPart, monthsPart, daysPart].filter((s) => s).join(' ');
};
